import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ReportsOverviewDataProvider } from '@services/admin/reports/reports-overview.data.service';
import { Subject } from 'rxjs/Subject';
import { filter } from 'rxjs/operators';
import {
	ReportCategoryItems,
	ReportOverviewList,
	ReportsTab
} from '@models/admin/reports.model';

@Component({
	selector: 'reports-overview',
	template: require('./reports-overview.component.html'),
	styles: [require('./reports-overview.component.scss')],
	encapsulation: ViewEncapsulation.None
})
export class ReportsOverviewComponent implements OnInit, OnDestroy {
	tab: ReportsTab;

	tabs: ReportsTab[] = [];
	private unsubscribe: Subject<void> = new Subject();

	constructor(private reportsOverviewService: ReportsOverviewDataProvider) {}

	ngOnInit(): void {
		this.getOverviewList();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private getOverviewList(): void {
		this.reportsOverviewService
			.getSettingsOverviewItems()
			.pipe(filter(data => data !== null))
			.subscribe((data: ReportOverviewList): void => {
				for (let i = 0; i < data.reports.length; i++) {
					this.tab = {
						expandedIn: false,
						name: data.reports[i].category,
						reportsList: data.reports[i].items
					};

					this.tabs.push(this.tab);
				}
			});
	}

	saveExpanded(event: any, index: number): void {
		this.tabs[index].expandedIn = event.currentTarget.ariaExpanded !== 'true';

		if (!event.currentTarget.ariaExpanded) {
			const expanded =
				event.currentTarget.getAttribute('aria-expanded') === 'true';
			event.currentTarget.setAttribute('aria-expanded', !expanded);
			this.tabs[index].expandedIn =
				event.currentTarget.getAttribute('aria-expanded') === 'true';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/admin/report/overview/reports-overview.component.ts